import { defineStore } from 'pinia'
import InviteCooperateHistoryService from "@/services/InviteCooperateHistoryService.ts";
export const useConnectHistoryStore = defineStore('connectHistory', {
    state: () => {
        return {
            connectHistory: {},
        }
    },
    persist: true,
    actions: {
        async getInviteCooperateHistory(url, params) {
            try {
                const inviteCooperateHistory = await InviteCooperateHistoryService.getInviteCooperateHistory(url, params)
                return this.connectHistory = inviteCooperateHistory.data;
            } catch (e) {
                return null
            }
        },
    }
})
